
  import { mapState } from 'vuex'

  export default {
    data() {
      return {
        upsells: [],
        added: [],
        imgPath: process.env.GW_ENV === 'stage' || process.env.GW_ENV === 'prod' ? 'https://olo-images-live.imgix.net/' : 'https://olo-images-sandbox.imgix.net/',
      }
    },
    computed: {
      ...mapState(['menu', 'order', 'channel', 'location']),
      isCatering() {
        return (
          this.channel === 'catering' || window.location.href.includes('catering')
        )
      },
    },
    async mounted() {
      this.upsells = await this.$api.getUpsellsForCart()
    },
    methods: {
      async getUpsells() {
        this.upsells = await this.$api.getUpsellsForCart()
      },
      getImage(upsell) {
        const product = this.menu.categories
          .flatMap(category => category.products)
          .find(product => product.id === upsell.id)
        return product
          ? `${this.imgPath}${product.images?.find(img => img.groupname === 'mobile-webapp-menu')?.filename}`
          : null
      },
      open(upsell) {
        const product = this.menu.categories
          .flatMap(category => category.products)
          .find(product => product.id === upsell.id)
        this.$store.commit('setShowCart', false)
        this.$router.push(`/order/product?id=${product.sku}`)
        if (this.$route.name == 'order-product') {
          setTimeout(() => {
            this.$router.go(`/order/product?id=${product.sku}`)
          },100)
        }
      },
      getEventData(item) {
        const eventItem = {
          'item_id': item.id,
          'item_name': item.name,
          'price': item.cost,
          'quantity': 1,
        }

        const category = this.menu.categories.find(c => c.products.find(p => p.name === eventItem.item_name))
        if (category) {
          eventItem.item_list_id = category.id
          eventItem.item_list_name = category.name
          eventItem.item_category = category.name
        }

        return {
          'ecommerce': {
            'affiliation': this.channel,
            'items': [eventItem],
            'currency': 'USD',
            'item_list_id': eventItem.item_list_id,
            'item_list_name': eventItem.item_list_name,
            'item_category': eventItem.item_category,
            'location_name': this.location?.name,
            'location_code': this.location?.id,
            'price':  eventItem.cost,
          }
        }
      },
      getBeginCheckoutEventData() {
        const eventItems = this.order.products.map((item, index) => {
          const category = this.menu.categories.find(c => c.products.find(p => p.name === item.name))
          const itemData = {
            'index': index,
            'item_id': item.id,
            'item_name': item.name,
            'price': item.cost.total,
            'quantity': item.quantity,
          }

          if (category) {
            itemData.item_list_id = category.id
            itemData.item_list_name = category.name
            itemData.item_category = category.name
          }

          return itemData
        })

        const orderType = this.order?.handoff == 'dispatch' ? 'delivery' : this.order?.handoff || ''

        return {
          'ecommerce': {
            'affiliation': this.channel,
            'items': eventItems,
            'currency': 'USD',
            'location_name': this.location?.name,
            'location_code': this.location?.id,
            'order_type': orderType,
            'price':  this.order.totals.subtotal,
          }
        }
      },
      async addToCart(item) {
        const order = await this.$api.addToOrder([{
          id: item.id,
          quantity: 1,
          choices: [],
          isupsell: true
        }])

        if (order) {
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            'event': 'add_to_cart',
            ...this.getEventData(item)
          });
          const orderType = this.isCatering ? 'Catering' : 'Mealtime'
          this.$braze.logCustomEvent('Add_Product_To_Cart', {
            Product: item,
            Cart_Items: this.order.products,
            Cart_Cost: this.order.totals.total,
            Channel: orderType
          })

          if (this.$route.name === 'order-checkout') {
            window.dataLayer.push({
              'event': 'begin_checkout',
              ...this.getBeginCheckoutEventData()
            });
          }

          this.$store.commit('setErrors', [])

          if (process.browser) {
            try {
              const bag = document.querySelector('.bag')
              bag.classList.add('bounce')
              setTimeout(function () {
                bag.classList.remove('bounce')
              }, 700)
            } catch (err) {}
          }
        } else {
          this.$store.commit('setErrors', ['Error adding to cart'])
        }
      },
      // getImage(upsell) {
      //   let image = null
      //   this.menu.categories.forEach(category => {
      //     category.products.forEach(product => {
      //       if (product.id == upsell.id) {
      //         image = this.imgPath+product.images?.find((n) => {
      //           return n.groupname === 'mobile-webapp-menu'
      //         }).filename
      //       }
      //     })
      //   })
      //   return image
      // },
      // customize(item) {
      //   const currentId = this.$route.query.id
      //   const newId = item.sku
      //   if (currentId !== newId) {
      //     const link = {
      //       path: '/order/product',
      //       query: {
      //         id: newId
      //       }
      //     };
      //     console.log(link)
      //     this.$router.push(link)

      //     if (this.$route.name == 'order-product') {
      //       setTimeout(() => {
      //         this.$router.go(link)
      //       },250)
      //     }
      //     this.$store.commit('setShowCart', false)
      //   }
      // },
      // productImage(item) {
      //   if (item.images === null) return this.defaultImg
      //   try {
      //     const img = item.images.find((n) => {
      //       return n.groupname === 'marketplace-product'
      //     }).filename
      //     return img ? `${this.imgPath}${img}` : this.defaultImg
      //   } catch (err) {
      //     console.error(err)
      //     return this.defaultImg
      //   }
      // }
    },
    watch: {
      'order.products': {
        handler(newVal, oldVal) {
          if (newVal.length !== oldVal.length) {
            // Refresh upsells if an item is removed or added
            this.getUpsells()
          }
        },
        deep: true
      }
    }
  }
